import React, {
  useState,
  createContext,
  useEffect,
  useRef
} from 'react';

import './functionalpagelogin.css';

import LeftSidebar from './leftSidebar/LeftSidebar.jsx';
import LearningPath from './learningPath/LearningPath.jsx';

import GetProCard from './rightSidebar/components/GetProCard.jsx';
import LeaderboardCard from './rightSidebar/components/LeaderboardCard.jsx';
import DailyGoalsCard from './rightSidebar/components/DailyGoalsCard.jsx';
import FooterElements from './rightSidebar/components/FooterElements.jsx';
import MotivationalMission from './rightSidebar/components/MotivationalMission.jsx';
import MotivationalClasament from './rightSidebar/components/MotivationalClasament.jsx';
import CerificateButton from './rightSidebar/components/CerificateButton.jsx';
import SocialElements from './rightSidebar/components/SocialElements.jsx';

import courseConfigs from '../../config/courseConfigs.js';
import ContaPrimaraProgressPanel from '../cursuri/contaprimara/ContaPrimaraProgressPanel.jsx';

import Certificate from './leftSidebar/pages/certificates/Certificate.jsx';
import Clasament from './leftSidebar/pages/leaderboard/Clasament.jsx';
import FullLeaderboard from './leftSidebar/pages/leaderboard/FullLeaderboard.jsx';
import CoursesInPlace from './leftSidebar/pages/courses/CoursesInPlace.jsx';
import Medalii from './leftSidebar/pages/medals/Medalii.jsx';
import Misiuni from './leftSidebar/pages/missions/Misiuni.jsx';
import Profil from './leftSidebar/pages/profile/Profil.jsx';
import ContaPrimaraCourse from '../cursuri/contaprimara/ContaPrimaraCourse.jsx';

import Settings from '../../settings/Settings.jsx';

export const PageNavContext = createContext();

const FunctionalPageLoginStart = () => {
  const topRef = useRef(null);

  const rightSidebarRef = useRef(null);
  const rightMenuRef = useRef(null);

  const [rightMenuOffset, setRightMenuOffset] = useState(0);

  const [selectedMenu, setSelectedMenu] = useState('Invata');
  const [activeTab, setActiveTab] = useState('profil');

  const [selectedCourseId, setSelectedCourseId] = useState(() => {
    const savedCourseId =
      localStorage.getItem('selectedCourseId');

    const parsedCourseId = savedCourseId
      ? Number(savedCourseId)
      : 1;

 return [1, 2, 3].includes(parsedCourseId)
  ? parsedCourseId
  : 1;
  });


  /* =====================================================
     SCROLL PAGE TO TOP
  ===================================================== */

  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({
        behavior: 'instant',
        block: 'start'
      });
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, []);


  /* =====================================================
     RIGHT MENU SCROLL
     Doar pentru pagina INVATA
  ===================================================== */

  useEffect(() => {
    if (selectedMenu !== 'Invata') {
      setRightMenuOffset(0);
      return;
    }

    const scroller = document.querySelector(
      '.line-lesson-gackground-functional'
    );

    const rightSidebar = rightSidebarRef.current;
    const rightMenu = rightMenuRef.current;

    if (
      !scroller ||
      !rightSidebar ||
      !rightMenu
    ) {
      return;
    }

    let previousScrollTop = scroller.scrollTop;

    const getMaxOffset = () => {
      const sidebarRect =
        rightSidebar.getBoundingClientRect();

      const menuHeight =
        rightMenu.scrollHeight;

      const bottomGap = 20;

      const availableHeight =
        window.innerHeight -
        sidebarRect.top -
        bottomGap;

      return Math.max(
        0,
        menuHeight - availableHeight
      );
    };


    const handleLessonScroll = () => {
      const currentScrollTop =
        scroller.scrollTop;

      const delta =
        currentScrollTop -
        previousScrollTop;

      previousScrollTop =
        currentScrollTop;

      const maxOffset =
        getMaxOffset();

      setRightMenuOffset(
        (currentOffset) => {
          const nextOffset =
            currentOffset + delta;

          return Math.max(
            0,
            Math.min(
              nextOffset,
              maxOffset
            )
          );
        }
      );
    };


    const handleResize = () => {
      const maxOffset =
        getMaxOffset();

      setRightMenuOffset(
        (currentOffset) =>
          Math.min(
            currentOffset,
            maxOffset
          )
      );
    };


    scroller.addEventListener(
      'scroll',
      handleLessonScroll,
      {
        passive: true
      }
    );

    window.addEventListener(
      'resize',
      handleResize
    );


    return () => {
      scroller.removeEventListener(
        'scroll',
        handleLessonScroll
      );

      window.removeEventListener(
        'resize',
        handleResize
      );
    };
  }, [
    selectedMenu,
    selectedCourseId
  ]);


  /* =====================================================
     COURSE SELECT
  ===================================================== */

  useEffect(() => {
    const handleCourseSelected = (event) => {
      const courseId =
        Number(event.detail);

   if (![1, 2, 3].includes(courseId)) {
  return;
}

      setSelectedCourseId(courseId);

      localStorage.setItem(
        'selectedCourseId',
        String(courseId)
      );

      setSelectedMenu('Invata');
      setRightMenuOffset(0);
    };


    window.addEventListener(
      'courseSelected',
      handleCourseSelected
    );


    return () => {
      window.removeEventListener(
        'courseSelected',
        handleCourseSelected
      );
    };
  }, []);


  /* =====================================================
     PAGE NAVIGATION
  ===================================================== */

  const handlePageNav = (menu) => {
    setSelectedMenu(menu);
    setRightMenuOffset(0);
  };


  /* =====================================================
     ACTIVE COURSE
  ===================================================== */

  const activeCourseConfig =
    selectedCourseId === 2
      ? courseConfigs.financiara
      : courseConfigs.baze;


      const learnContent =
  selectedCourseId === 3 ? (
    <ContaPrimaraCourse />
  ) : (
    <LearningPath
      courseConfig={activeCourseConfig}
    />
  );

  const isContaPrimaraCourse =
  selectedMenu === 'Invata' &&
  selectedCourseId === 3;

  const isFixedPage = [
  'Clasament',
  'Misiuni',
  'Certificate',
  'Profil'
].includes(selectedMenu);


useEffect(() => {
  if (!isFixedPage) {
    return;
  }

  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'instant'
  });
}, [selectedMenu, isFixedPage]);


  /* =====================================================
     CENTER CONTENT
  ===================================================== */

  const menuComponents = {
  Invata: learnContent,

    Profil: (
      <Profil
        onMenuSelect={handlePageNav}
      />
    ),

    Certificate: (
      <Certificate />
    ),

    Clasament: (
      <Clasament />
    ),
    
    FullLeaderboard: (
  <FullLeaderboard />
),

    Medalii: (
      <Medalii />
    ),

    Misiuni: (
      <Misiuni />
    ),

    CoursesInPlace: (
      <CoursesInPlace />
    ),

    Setari: (
      <Settings
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        onBackToProfile={() => {
          handlePageNav('Profil');
        }}
      />
    )
  };


const currentContent =
  menuComponents[selectedMenu] || learnContent;


  /* =====================================================
     RIGHT MENU CONTENT
  ===================================================== */

  const rightMenuComponents = {
    Invata: (
      <>
        <GetProCard />
        <LeaderboardCard />
        <DailyGoalsCard />
        <FooterElements />
        <SocialElements />
      </>
    ),

    Misiuni: (
      <>
        <GetProCard />
        <MotivationalMission />
        <FooterElements />
         <SocialElements />
      </>
    ),

    Clasament: (
      <>
        <GetProCard />
        <MotivationalClasament />
        <FooterElements />
         <SocialElements />
      </>
    ),

    Certificate: (
      <>
        <GetProCard />
        <CerificateButton />
        <FooterElements />
         <SocialElements />
      </>
    ),

    Profil: (
      <>
        <GetProCard />
        <FooterElements />
         <SocialElements />
      </>
    )
  };


  const currentRightMenu =
    rightMenuComponents[selectedMenu] || (
      <>
        <GetProCard />
        <FooterElements />
         <SocialElements />
      </>
    );


  /* =====================================================
     RENDER
  ===================================================== */

  return (
    <PageNavContext.Provider
      value={handlePageNav}
    >
<div
  ref={topRef}
  className={`functional-page-layout ${
    isFixedPage
      ? 'functional-page-layout--fixed'
      : ''
  }`}
>

        {/* LEFT SIDEBAR */}

        <aside className="functional-page-left">
          <LeftSidebar
            onMenuSelect={handlePageNav}
            selectedMenu={selectedMenu}
          />
        </aside>


        {/* CENTER + RIGHT */}

      <section
  className={`functional-page-main ${
    isFixedPage
      ? 'functional-page-main--fixed'
      : ''
  }`}
>

<div
  className={`functional-page-main-inner ${
    isContaPrimaraCourse
      ? 'functional-page-main-inner--course-layout'
      : ''
  } ${
    selectedMenu === 'CoursesInPlace'
      ? 'functional-page-main-inner--courses'
      : ''
  } ${
    isFixedPage
      ? 'functional-page-main-inner--fixed'
      : ''
  }`}
>

            {/* CENTER */}

<main
  className={`functional-page-content ${
    isFixedPage
      ? 'functional-page-content--fixed'
      : ''
  }`}
>
  {currentContent}
</main>


            {/* RIGHT */}

       {/* RIGHT */}

{selectedMenu !== 'Setari' && (
  <aside
    ref={rightSidebarRef}
    className={`functional-page-right ${
      isContaPrimaraCourse
        ? 'functional-page-right--course'
        : ''
    }`}
  >
    {isContaPrimaraCourse ? (
      <ContaPrimaraProgressPanel />
    ) : (
      <div
        ref={rightMenuRef}
        className="functional-page-right-inner"
        style={{
          transform:
            selectedMenu === 'Invata'
              ? `translateY(-${rightMenuOffset}px)`
              : 'translateY(0)'
        }}
      >
        {currentRightMenu}
      </div>
    )}
  </aside>
)}

          </div>

        </section>

      </div>
    </PageNavContext.Provider>
  );
};

export default FunctionalPageLoginStart;